import { render, staticRenderFns } from "./LicenseDetailsLogBook.vue?vue&type=template&id=0fbcf604&"
import script from "./LicenseDetailsLogBook.vue?vue&type=script&lang=js&"
export * from "./LicenseDetailsLogBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports